import RESTSerializer from '@ember-data/serializer/rest';
import { underscore } from '@ember/string';

export default class RegisterStakeholderSerializer extends RESTSerializer {
  modelNameFromPayloadKey() {
    return 'register-stakeholder';
  }

  payloadKeyFromModelName() {
    return 'stakeholder';
  }

  keyForAttribute(attr) {
    return underscore(attr);
  }

  keyForRelationship(key) {
    if (key === 'organization') {
      return 'organization_id';
    }

    if (key === 'documents') {
      return 'document_ids';
    }

    return key;
  }
}
